<template>
  <nav class="header-nav">
    <div class="container">
      <router-link :class="{'active': activeLink == 'kakusan'}" to="/kakusan">何謂核酸？</router-link>
      <router-link :class="{'active': activeLink == 'investigate'}" to="/kakusan/investigate">學術研究</router-link>
    </div>
  </nav>
</template>
<script>
export default {
  name: "KakusanHeaderNav",
  props: ["activeLink"],
};
</script>